import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Layout } from "antd";
import { useState } from "react";
import AboutUsModal from "../AboutUs";

const { Header } = Layout;

const HeaderComponent: React.FC = () => {
  const [isAboutUsVisible, setIsAboutUsVisible] = useState(false);

  return (
    <Header
      className="flex w-full items-center h-[70px] justify-between border-b border-solid border-gray-300 bg-[#f8f8f8]"
    >
      <div className="flex items-center">
        <img
          src="/images/logos-with-info.png"
          alt="ChiroFutures Logo"
          className="mr-4 h-[60px]"
        />
      </div>

      <div className="flex items-center gap-4">
        <div className="flex flex-col text-right leading-snug">
          <a
            href="mailto:chirofutures@sonorannational.com"
            className="text-[#1890ff] no-underline"
          >
            E-mail: chirofutures@sonorannational.com
          </a>
          <span>Phone: (800) 219-9090</span>
        </div>

        <div>
          <Button
            type="text"
            shape="circle"
            icon={<InfoCircleOutlined />}
            className="text-lg text-[#1890ff]"
            onClick={() => setIsAboutUsVisible(true)}
            aria-label="About us"
          />
          <AboutUsModal
            visible={isAboutUsVisible}
            onCancel={() => setIsAboutUsVisible(false)}
          />
        </div>
      </div>
    </Header>
  );
};

export default HeaderComponent;
